import {
  FormControl,
  FormHelperText,
  InputAdornment,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { Stack, useTheme } from "@mui/system";
import React, { useRef } from "react";

const AutobiaInput = ({
  title,
  icon,
  value,
  onChange,
  placeholder,
  onKeyPress,
  name,
  onBlur,
  error = false,
  helperText,
  height = "40px",
  color = "primary",
  maxLength = null,
  type = "text",
  disabled = false,
  fullWidth = true,
}) => {
  const theme = useTheme();
  const inputRef = useRef(null);

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.select();
    }
  };

  return (
    <Stack sx={{ width: fullWidth ? "100%" : "auto" }}>
      {title && (
        <Typography
          variant="body2"
          color={theme.palette.gray.g600}
          fontWeight={600}
          sx={{ mb: 0.5 }}
        >
          {title}
        </Typography>
      )}
      <FormControl
        fullWidth={fullWidth}
        error={error}
        variant="outlined"
      >
        <OutlinedInput
          name={name}
          onBlur={onBlur}
          color={color}
          type={type}
          disabled={disabled}
          sx={{
            borderRadius: "10px",
            height: height,
            backgroundColor: "white",
            width: "100%",
            px: "1rem",
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: color === "secondary"
                ? theme.palette.secondary.main
                : theme.palette.primary.main,
            },
            "&.Mui-disabled": {
              backgroundColor: theme.palette.gray.g50,
            },
          }}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyPress={onKeyPress}
          endAdornment={
            icon && <InputAdornment position="end">{icon}</InputAdornment>
          }
          inputRef={inputRef}
          onClick={handleClick}
          inputProps={{
            maxLength: maxLength,
          }}
        />
        {helperText && (
          <FormHelperText sx={{ mt: 0.5 }}>
            {helperText}
          </FormHelperText>
        )}
      </FormControl>
    </Stack>
  );
};

export default AutobiaInput;